import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 70.1 77.3"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M51.4 10.9q-.9-.9-2.1-.9H12.6c-2.8 0-5.1 3.2-5.1 7.2v43.2c0 4 2.3 7.2 5.1 7.2h44c2.8 0 5.1-3.2 5.1-7.2V23.1c0-.8-.3-1.6-.8-2.2zM25.8 45.4l-5.5 5.5c-.7.7-1.9.7-2.6 0l-1.8-1.8c-.7-.7-.7-1.9 0-2.6s1.9-.7 2.6 0l.5.5 4.2-4.2c.7-.7 1.9-.7 2.6 0s.7 1.9 0 2.6m0-14.6-5.5 5.5c-.7.7-1.9.7-2.6 0l-1.8-1.8c-.7-.7-.7-1.9 0-2.6s1.9-.7 2.6 0l.5.5 4.2-4.2c.7-.7 1.9-.7 2.6 0s.7 1.9 0 2.6m25.5 16.9H33.1c-1 0-1.8-.8-1.8-1.8s.8-1.8 1.8-1.8h18.2c1 0 1.8.8 1.8 1.8s-.8 1.8-1.8 1.8m0-14.6H33.1c-1 0-1.8-.8-1.8-1.8s.8-1.8 1.8-1.8h18.2c1 0 1.8.8 1.8 1.8s-.8 1.8-1.8 1.8",
      style: {"fill":"#000","stroke-width":"0"}
    }, null, -1)
  ])))
}
export default { render: render }